import { Container } from '@mui/material';
import styles from '../../../assets/styles/privacypolicy';

const PrivacyPolicy = () => {
	const classes = styles();
	return (
		<Container maxWidth="md" className={classes.containerClass}>
			<div className={classes.contentContainer}>
				<div className={classes.titleContainer}>Privacy Policy</div>
				<div className={classes.textContainer}>
					<div className={classes.titleText}>Last modified: 17-Aug-2023 </div>
					<p>
						This Privacy Policy applies to all personal information collected by
						B4Tax (part of GREATER DANDENONG BOOKKEEPING SERVICES) via the
						website located at www.b4tax.com.au.
					</p>
					<div className={classes.mainContent}>
						<ul className={classes.mainOrderedListContainer}>
							<b>
								<li>
									<p>1) What is "personal information"?</p>
									<ol type="a" className={classes.orderedListContainer}>
										<li className={classes.childList}>
											The Privacy Act 1988 (Cth) currently defines "personal
											information" as meaning information or an opinion about an
											identified individual or an individual who is reasonably
											identifiable:
											<ol type="i">
												<li>
													whether the information or opinion is true or not; and
												</li>
												<li>
													whether the information or opinion is recorded in a
													material form or not.
												</li>
											</ol>
										</li>
										<li className={classes.childList}>
											If the information does not disclose your identity or
											enable your identity to be ascertained, it will in most
											cases not be classified as "personal information" and will
											not be subject to this privacy policy.
										</li>
									</ol>
								</li>
							</b>
							<b>
								<li>
									<p>2) What information do we collect?</p>
									<div className={classes.childText}>
										The kind of personal information that we collect from you
										will depend on how you use the website. The personal
										information which we collect and hold about you may include:
										login credentials email address address name payment details
										phone number.
									</div>
								</li>
							</b>
							<b>
								<li>
									<p>3) How we collect your personal information</p>
									<ol type="a" className={classes.orderedListContainer}>
										<li className={classes.childList}>
											We may collect personal information from you whenever you
											input such information into the website
										</li>
										<li className={classes.childList}>
											We also collect cookies from your computer which enable us
											to tell when you use the website and also to help
											customise your website experience. As a general rule,
											however, it is not possible to identify you personally
											from our use of cookies
										</li>
									</ol>
								</li>
							</b>
							<b>
								<li>
									<p>4) Purpose of collection</p>
									<ol type="a" className={classes.orderedListContainer}>
										<li className={classes.childList}>
											The purpose for which we collect personal information is
											to provide you with the best service experience possible
											on the website.
										</li>
										<li className={classes.childList}>
											We customarily disclose personal information only to our
											service providers who assist us in operating the website.
											Your personal information may also be exposed from time to
											time to maintenance and support personnel acting in the
											normal course of their duties.
										</li>
										<li className={classes.childList}>
											By using our website, you consent to the receipt of direct
											marketing material. We will only use your personal
											information for this purpose if we have collected such
											information direct from you, and if it is material of a
											type which you would reasonably expect to receive from us.
											We do not use sensitive personal information in direct
											marketing activity. Our direct 5. 6. 7. 8. marketing
											material will include a simple means by which you can
											request not to receive further communications of this
											nature.
										</li>
									</ol>
								</li>
							</b>
							<b>
								<li>
									<p>5) Access and correction</p>
									<div className={classes.childText}>
										Australian Privacy Principle 12 permits you to obtain access
										to the personal information we hold about you in certain
										circumstances, and Australian Privacy Principle 13 allows
										you to correct inaccurate personal information subject to
										certain exceptions. If you would like to obtain such access,
										please contact us as set out below.
									</div>
								</li>
							</b>
							<b>
								<li>
									<p>6) Complaint procedure</p>
									<div className={classes.childText}>
										If you have a complaint concerning the manner in which we
										maintain the privacy of your personal information, please
										contact us as set out below. All complaints will be
										considered by Sam Lentini and we may seek further
										information from you to clarify your concerns. If we agree
										that your complaint is well founded, we will, in
										consultation with you, take appropriate steps to rectify the
										problem. If you remain dissatisfied with the outcome, you
										may refer the matter to the Office of the Australian
										Information Commissioner.
									</div>
								</li>
							</b>
							<b>
								<li>
									<p>7) Overseas transfer</p>
									<div className={classes.childText}>
										Your personal information may be transferred overseas or
										stored overseas for a variety of reasons. It is not possible
										to identify each and every country to which your personal
										information may be sent. If your personal information is
										sent to a recipient in a country with data protection laws
										which are at least substantially similar to the Australian
										Privacy Principles, and where there are mechanisms available
										to you to enforce protection of your personal information
										under that overseas law, we will not be liable for a breach
										of the Australian Privacy Principles if your personal
										information is mishandled in that jurisdiction. If your
										personal information is transferred to a jurisdiction which
										does not have data protection laws as comprehensive as
										Australia's, we will take reasonable steps to secure a
										contractual commitment from the recipient to handle your
										information in accordance with the Australian Privacy
										Principles.
									</div>
								</li>
							</b>
							<b>
								<li>
									<p>8) How to contact us about privacy</p>
									<div className={classes.childText}>
										If you have any queries, or if you seek access to your
										personal information, or if you have a complaint about our
										privacy practices, you can contact us through:
										<b> sam@dandybooks.com.au.</b>
									</div>
								</li>
							</b>
						</ul>
					</div>
				</div>
			</div>
		</Container>
	);
};

export default PrivacyPolicy;
